import React from 'react';
import { ListItemButton, ListItemText, Paper } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import OrgAvatar from '../../../Components/OrgAvatar';

const SettingsOrgProfile = ({ organization, planLabel, onClick }) => {
	const name = organization?.name || 'Organization';
	const subtitle = planLabel
		? `${planLabel} plan`
		: organization?.from_email || organization?.phone || 'Company profile';

	return (
		<Paper
			variant="outlined"
			sx={{
				borderRadius: 2,
				overflow: 'hidden',
			}}
		>
			<ListItemButton onClick={onClick} sx={{ py: 1.75, px: 2, gap: 1.5 }}>
				<OrgAvatar
					organization={organization}
					size={56}
					sx={{
						borderRadius: '50%',
						boxShadow: (theme) =>
							`inset 0 0 0 1px ${theme.palette.divider}`,
					}}
				/>
				<ListItemText
					primary={name}
					secondary={subtitle}
					primaryTypographyProps={{
						fontWeight: 700,
						fontSize: '1.05rem',
						sx: { wordBreak: 'break-word' },
					}}
					secondaryTypographyProps={{
						fontSize: '0.8125rem',
						sx: { mt: 0.15 },
					}}
					sx={{ my: 0 }}
				/>
				<ChevronRightIcon
					sx={{ color: 'text.disabled', flexShrink: 0 }}
					aria-hidden
				/>
			</ListItemButton>
		</Paper>
	);
};

export default SettingsOrgProfile;
